export function normalizeUploadedImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.pathname.startsWith('/api/uploads/')) return `${parsed.pathname}${parsed.search}`;
    if (parsed.pathname.startsWith('/uploads/')) return `/api${parsed.pathname}${parsed.search}`;
    return url;
  } catch {
    return url.startsWith('/uploads/') ? `/api${url}` : url;
  }
}
